import { isCentificUser } from '@dmp/utils/rbac';

/**
 * Determines if the Agency Catalog link should be visible
 * Only Centific users (@centific.com) should see this link when logged in
 *
 * @param isLoggedIn - Whether the user is authenticated
 * @param userEmail - User's email address
 * @returns true if Agency Catalog should be shown
 */
export const shouldShowAgencyCatalog = (isLoggedIn: boolean, userEmail?: string): boolean => {
  if (!isLoggedIn) return false;
  return isCentificUser(userEmail) ?? false;
};

/**
 * Gets the CSS class for active navigation links
 *
 * @param currentPath - Current route path
 * @param targetPath - Target route path to compare
 * @returns CSS class string for active state
 */
export const getActiveClass = (currentPath: string, targetPath: string): string => {
  return currentPath === targetPath ? 'border-b-2 border-[#0038FF]' : '';
};
